module.exports = __webpack_public_path__ + "static/Elyseos Logo-b3a99983872d9ab1e973576ebd85fd51.png";